import { NgModule } from '@angular/core';
import { BaseModule } from '../shared/base.module';
import { PatientsModalModule } from '../patients/modals/patients-modal.module';

import { PatientComponent } from './patient.component';
import { PatientRoutesModule } from './patient.routes';
import { ProgressbarComponent } from '../shared/progressbar/progressbar.component';
import { TinymceModule } from 'angular2-tinymce';
import { SymptomMapModule } from './symptom-map/symptom-map.module';
import { MyDatePickerModule } from 'mydatepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DialogModule } from '../dialog/dialog.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DragulaModule } from 'ng2-dragula';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { SharedPopoverModule } from '../shared/popover/popover.module';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
};

import { MATERIALS } from '../app.materials';

// ngx-bootstrap modules
import {AccordionModule} from 'ngx-bootstrap/accordion';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import { CreateSEModalModule } from './create-se-modal/create-se-modal.module';
import { PatientMenuActionModule } from './patient-menu/patient-menu-action.module';
import { PatientQuestionnairesComponent } from './patient-questionnaires/patient-questionnaires.component';
import { PatientSelectedDiagnosesComponent } from './patient-selected-diagnoses/patient-selected-diagnoses.component';
import { ProposalDiagnosisModule } from './proposal-diagnosis/proposal-diagnosis.module';
import { ConfirmModalBodyModule } from '../shared/confirm-modal-body/confirm-modal-body.module';
import { BreadcrumbModule } from '../shared/breadcrumb/breadcrumb.module';
import { ImageUploadModule } from 'angular2-image-upload';
import { ContactPatientModalModule } from './contact-patient-modal/contact-patient-modal.module';
import { TherapyOffersModule } from './therapy-offers/therapy-offers.module';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SuicidalityModule } from './suicidality/suicidality.module';
import { ProposalDiagnosisService } from './proposal-diagnosis/proposal-diagnosis.service';

@NgModule({
    imports: [
        MATERIALS,
        BaseModule,
        PatientRoutesModule,
        PatientsModalModule,
        AccordionModule.forRoot(),
        BsDropdownModule.forRoot(),
        CollapseModule.forRoot(),
        TabsModule.forRoot(),
        ModalModule.forRoot(),
        PopoverModule.forRoot(),
        TooltipModule.forRoot(),
        TinymceModule.withConfig({
            menubar: false,
            elementpath: false,
            toolbar: 'bold italic alignleft numlist bullist link formatselect'
        }),
        SymptomMapModule,
        MyDatePickerModule,
        ImageUploadModule.forRoot(),
        DialogModule,
        DragulaModule,
        PerfectScrollbarModule,
        SharedPopoverModule,
        CreateSEModalModule,
        ContactPatientModalModule,
        PatientMenuActionModule,
        ProposalDiagnosisModule,
        BreadcrumbModule,
        ConfirmModalBodyModule,
        TherapyOffersModule,
        SuicidalityModule,
        MatSelectModule,
        NgxMatSelectSearchModule
    ],
    declarations: [
        PatientComponent,
        ProgressbarComponent,
        PatientQuestionnairesComponent,
        PatientSelectedDiagnosesComponent,
    ],
    exports: [
    ],
    providers: [
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        },
        ProposalDiagnosisService
    ]
})

export class PatientModule {
}
